<template lang="pug">
section#dados-lote.upload-info
    hr.upload-info__divider

    .upload-info__container
        span.upload-info__title Datos del último lote

        .upload-info__grid
            .upload-info__item
                span.upload-info__label Hoja de cálculo importada:
                el-tooltip(
                    effect='dark'
                    :content='dadosLote.planilha'
                    placement='top'
                )
                    span.upload-info__value.ellipsis {{ dadosLote.planilha }}

            .upload-info__item(v-if='dadosLote.planilhaErro')
                span.upload-info__label Hoja de cálculo con error:
                el-button(
                    type='primary'
                    size='mini'
                    icon='el-icon-download'
                    @click='fazerDownload(dadosLote.id)'
                ) Descargar

            .upload-info__item
                span.upload-info__label Fecha de registro:
                span.upload-info__value {{ dadosLote.dataCadastro }}

            .upload-info__item
                span.upload-info__label Última actualización:
                span.upload-info__value {{ dadosLote.dataAtualizacao }}

            .upload-info__item
                span.upload-info__label Status:
                el-tag(:type='statusMapper[dadosLote.status].class')
                    i.el-icon-loading.upload-info__icon(v-if='statusMapper[dadosLote.status]?.loading')
                    span.upload-info__value {{ statusMapper[dadosLote.status].label }}
</template>

<script>
import TerritorioServiceArgentina from '@/services/TerritorioServiceArgentina.js';

export default {
    name: 'DadosLote',
    props: {
        dadosLote: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            statusMapper: {
                EM_PROCESSAMENTO: {
                    label: 'En procesamiento',
                    class: 'info',
                    loading: true
                },
                PROCESSADO_COM_ERRO: {
                    label: 'Procesado parcialmente con un error',
                    class: 'warning'
                },
                PROCESSADO: {
                    label: 'Processado',
                    class: 'success'
                },
                ERRO_PROCESSAR: {
                    label: 'Procesamiento de errores',
                    class: 'danger'
                }
            }
        };
    },

    methods: {
        async fazerDownload(id) {
            try {
                await TerritorioServiceArgentina.downloadPlanilhaComErro(id);
            } catch (error) {
                this.$notify.error('Error al recuperar los resultados del lote.');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.upload-info {
    hr {
        margin-top: 1rem;
        margin-bottom: 1rem;
        border: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    &__container {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    &__title {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    &__grid {
        display: grid;
        grid-template-columns: repeat(5, 1fr);

        .upload-info__item {
            display: flex;
            flex-direction: column;
            gap: 18px;
            width: 200px;

            .upload-info__label {
                font-weight: bold;
                color: var(--primary);
            }

            .upload-info__value {
                width: 200px;

                &.ellipsis {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden !important;
                }
            }
        }
    }

    .el-icon-loading {
        font-size: 15px;
        color: var(--primary);
        margin-right: 5px;
    }

    .el-button,
    .el-tag {
        width: fit-content;
        align-self: flex-start;
    }
}
</style>
